
    import Component from "vue-class-component";
    import CutieListAllContents from "@/app/views/cutie-lists/CutieListAllContents.vue";
    import Vue from "vue";
    import { DefaultCatch } from "catch-decorator-ts";
    import { defaultErrorHandler } from "@/common/utils/defaultErrorHandler";
    import type { CutieListAllEntry, Pagination, CutieFilterState, PetFilterOptions } from "@/app/cuties/list/CutieListApiService";
    import CutieListApiService from "@/app/cuties/list/CutieListApiService";
    import CutieListFiltersCriteria from "@/app/components/cutie/list/CutieListFiltersCriteria.vue";
    import { Emit, Prop, Watch } from "vue-property-decorator";
    import CutieListAllPagination from "@/app/views/cutie-lists/CutieListAllPagination.vue";

    @Component({
        components: { CutieListFiltersCriteria, CutieListAllContents, CutieListAllPagination },
    })
    export default class CutieListAllPaginatedContent extends Vue {
        @Prop({ required: true }) filterState!: CutieFilterState<string | number>;
        @Prop({ required: false, default: true }) showStats!: boolean;
        @Prop({ required: false }) initialPagination?: Pagination;

        private pagination: Pagination = {
            direction: "DESC",
            maxId: null,
        };
        /** in ID descending order */
        private cuties: CutieListAllEntry[] = [];
        private pageSize = 0;
        private loading = false;
        /**
         * preserves the order: last requested page is guaranteed to be rendered last
         * even if it loads faster than the previous one on quick filters manipulation
         */
        private lastPageRetrieval: Promise<unknown> = Promise.resolve();

        @DefaultCatch(defaultErrorHandler)
        async mounted() {
            this.pagination = this.initialPagination ?? {
                direction: "DESC",
                maxId: null,
            };
            const whenPage = this.loadPage();
            await whenPage;
        }

        @Emit("loadingPageOnAction")
        loadingPageOnAction() {
            return this.pagination;
        }

        @Emit("filterOptions")
        filterOptions(filterOptions: PetFilterOptions) {
            return filterOptions;
        }

        private async loadPage(): Promise<boolean> {
            const requestBase = {
                filterState: this.filterState,
            };
            this.loading = true;
            const whenResponse = this.pagination.direction === "ASC"
                ? CutieListApiService.listAllAsc({
                    ...requestBase, minId: this.pagination.minId
                })
                : CutieListApiService.listAllDesc({
                    ...requestBase, maxId: this.pagination.maxId
                });
            this.lastPageRetrieval = whenResponse;
            const response = await whenResponse
                .finally(() => this.loading = false);
            if (this.lastPageRetrieval !== whenResponse) {
                return false; // more recent request took place, cancel this one
            }
            this.pageSize = response.pageSize;
            this.cuties = response.cuties.sort((a, b) => b.id - a.id);
            this.filterOptions(response.filterOptions);
            return true;
        }

        @Watch("filterState")
        async onFilterStateChange() {
            await this.loadPageOnAction();
            if (this.cuties.length === 0) {
                if (this.tryChangeDirection()) {
                    await this.loadPageOnAction();
                }
            }
        }

        /** writes to browser history */
        @DefaultCatch(defaultErrorHandler)
        private async loadPageOnAction(): Promise<boolean> {
            this.loadingPageOnAction();
            return this.loadPage();
        }

        private moveToCutiePage(cutie: CutieListAllEntry) {
            this.$router.push({ path: "/" + this.$i18n.locale + "/pet/" + cutie.uid });
        }

        private tryChangeDirection(): boolean {
            if (this.pagination.direction === "ASC") {
                // changing direction is meaningless if page
                // is the last and the first at same time
                if (this.pagination.minId !== 0) {
                    this.pagination = {
                        direction: "DESC",
                        maxId: null,
                    };
                    return true;
                }
            } else {
                if (this.pagination.maxId !== null) {
                    this.pagination = {
                        direction: "ASC",
                        minId: 0,
                    };
                    return true;
                }
            }
            return false;
        }
    }
